import { render, staticRenderFns } from "./invitemember.vue?vue&type=template&id=53b42f26&"
import script from "./invitemember.vue?vue&type=script&lang=js&"
export * from "./invitemember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports